import { PageContent, TopControl } from './shared';
import { TopBarWrapper } from './top-bar/RedesignedTopBar';
import {
  StudioShimmerBlock,
  SidePanelHeader,
  SidePanelWrapper,
  ALLOCATOR_MAIN_WIDTH_WITH_HISTORICALS,
  ALLOCATOR_MAIN_WIDTH,
} from 'venn-components';
import React from 'react';
import styled from 'styled-components';
import { getTopBarColor } from './top-bar/shared';
import { useHasFF } from 'venn-utils';

export const StudioPageLoadingState = () => {
  const hasHistoricals = useHasFF('historical_portfolios_ff');

  return (
    <PageContent
      isMainLeftPanelOpen
      isAllocatorOpen={false}
      allocatorPanelWidth={hasHistoricals ? ALLOCATOR_MAIN_WIDTH_WITH_HISTORICALS : ALLOCATOR_MAIN_WIDTH}
      isLeftBlockConfigPanelOpen={false}
      inPrintMode={false}
      orientation="PORTRAIT"
    >
      <TopControl>
        <TopBarWrapper barColors={getTopBarColor({ isTemplate: false })} />
      </TopControl>
      <SidePanelWrapper>
        <SidePanelHeader>
          <PanelWrapper>
            <StudioShimmerBlock height={25} />
          </PanelWrapper>
        </SidePanelHeader>
        <PanelWrapper>
          <StudioShimmerBlock />
        </PanelWrapper>
      </SidePanelWrapper>
      <StudioShimmerBlock />
    </PageContent>
  );
};

const PanelWrapper = styled.div`
  margin: 10px 20px;
`;
